import * as PIXI from 'pixi.js';
import { APP_WIDTH, APP_HEIGHT, getProxiedCardImageUrl, CARD_WIDTH, CARD_HEIGHT, redrawFullScreenOverlay } from '../utils/commonUtils';
import AssetsLoader from '../utils/assetsLoader';
import { getGlobalEventEmitter } from '../utils/globalEventEmitter';

import HandContainer from './handContainer';
import CardContainer from './cardContainer';
import ActionButtonsContainer from './actionButtonsContainer';

export default class ChooseFromOpponentHandContainer extends PIXI.Container {
    constructor() {
        super();

        const searchDeckOverlayGraphics = new PIXI.Graphics();
        searchDeckOverlayGraphics.label = 'searchDeckOverlayGraphics';
        searchDeckOverlayGraphics.x = 0;
        searchDeckOverlayGraphics.y = 0;
        searchDeckOverlayGraphics.rect(-APP_WIDTH / 2, -APP_HEIGHT / 2, APP_WIDTH, APP_HEIGHT);
        searchDeckOverlayGraphics.fill({ color: '#000000' });
        searchDeckOverlayGraphics.alpha = 0.7;
        this.addChild(searchDeckOverlayGraphics);

        this.titleText = new PIXI.Text({
            text: 'Select a Target',
            style: {
                fontFamily: 'Caladea',
                fontWeight: '700',
                fontSize: 90,
                fill: '#ee8d1b',
            },
        });
        this.titleText.anchor.set(0.5, 1);
        this.titleText.x = 0;
        this.titleText.y = -600;
        this.addChild(this.titleText);

        this.subTitleText = new PIXI.Text({
            text: '',
            style: {
                fontFamily: 'Open Sans',
                fontWeight: '700',
                fontSize: 54,
                fill: '#ffffff',
            },
        });
        this.subTitleText.anchor.set(0.5, 1);
        this.subTitleText.x = 0;
        this.subTitleText.y = -520;
        this.addChild(this.subTitleText);

        const lineGradient = new PIXI.FillGradient({
            type: 'linear',
            start: { x: 0, y: 0.5 },
            end: { x: 1, y: 0.5 },
            colorStops: [
                { offset: 0, color: 'rgba(255, 255, 255, 0)' },
                { offset: 0.25, color: 'rgba(255, 255, 255, 1)' },
                { offset: 0.75, color: 'rgba(255, 255, 255, 1)' },
                { offset: 1, color: 'rgba(255, 255, 255, 0)' },
            ],
        });

        const lineGraphics1 = new PIXI.Graphics();
        lineGraphics1.label = 'lineGraphics1';
        lineGraphics1.x = 0;
        lineGraphics1.y = -500;
        lineGraphics1.rect(-APP_WIDTH / 2 + 50, -2, APP_WIDTH - 100, 4);
        lineGraphics1.fill(lineGradient);
        this.addChild(lineGraphics1);

        this.handContainer = new HandContainer(0, []);
        this.handContainer.label = 'handContainer';
        this.handContainer.scale.set(1.3);
        this.handContainer.x = 0;
        this.handContainer.y = 0;
        this.addChild(this.handContainer);

        this.noCardsFoundText = new PIXI.Text({
            text: 'No Cards Found',
            style: {
                fontFamily: 'Open Sans',
                fontWeight: '700',
                fontSize: 54,
                fill: '#ffffff',
            },
        });
        this.noCardsFoundText.anchor.set(0.5, 0.5);
        this.noCardsFoundText.x = 0;
        this.noCardsFoundText.y = 0;
        this.noCardsFoundText.visible = false;
        this.addChild(this.noCardsFoundText);

        this.selectedCardContainer = new CardContainer();
        this.selectedCardContainer.label = 'selectedCardContainer';
        this.selectedCardContainer.x = 0;
        this.selectedCardContainer.y = 0;
        this.selectedCardContainer.visible = false;
        this.selectedCardContainer.scale.set(1.3);
        this.addChild(this.selectedCardContainer);

        this.noSlectionSlotSprite = new PIXI.Sprite(PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.NO_SELECTION_SLOT));
        this.noSlectionSlotSprite.anchor.set(0.5, 1);
        this.noSlectionSlotSprite.x = 0;
        this.noSlectionSlotSprite.y = 0;
        this.noSlectionSlotSprite.visible = false;
        this.addChild(this.noSlectionSlotSprite);

        this.actionButtonsContainer = new ActionButtonsContainer();
        this.actionButtonsContainer.label = 'actionButtonsContainer';
        this.actionButtonsContainer.x = 0;
        this.actionButtonsContainer.y = 650;
        this.addChild(this.actionButtonsContainer);
    }

    update(gameState) {
        if (gameState.pendingAction?.type !== 'EFFECT_STEP_RESOLUTION' ||
            gameState.pendingAction?.expectedResponseType !== 'targetSelection' ||
            gameState.pendingAction?.currentStepData?.targetCriteria?.zone !== 'Hand' ||
            gameState.pendingAction?.currentStepData?.targetCriteria?.scope !== 'Opponent') {
            return;
        }

        const { title, subtitle } = gameState.pendingAction.currentStepData || {};
        this.titleText.text = title || 'Select a Target';
        this.subTitleText.text = subtitle || '';

        this.noCardsFoundText.visible = false;
    
        const cards = gameState.opponent.hand;
        const { validTargetsForCurrentStep } = gameState.pendingAction;
        const { selectedCard } = gameState.clientGameState;

        if (cards.length === 0) {
            this.noCardsFoundText.visible = true;
        }

        const playerState = { handCount: cards.length, hand: cards };

        this.selectedCardContainer.visible = false;
        this.noSlectionSlotSprite.visible = false;
        
        this.handContainer.visible = true;
        this.handContainer.scale.set(cards.length <= 5 ? 1.3 : 1.0);
        this.handContainer.y = 0;
        this.handContainer.updateHand(gameState, playerState, { playableCards: validTargetsForCurrentStep, selectedCard });

        if (selectedCard) {
            this.actionButtonsContainer.update({ clientGameState: { availableActions: ['NO_SELECTION', 'CONFIRM'] } });
        } else {
            this.actionButtonsContainer.update({ clientGameState: { availableActions: ['NO_SELECTION', { type: 'CONFIRM', disabled: true }] } });
        }
        
        this.actionButtonsContainer.y = 650;
    
    }

    resize(width, height) {
        redrawFullScreenOverlay(this.getChildByLabel('searchDeckOverlayGraphics'), width, height);
    }
}